import { Actions } from '../../action-types';
import { IApplicationState } from './types';

export const setInBetReferral = ({ inBetReferral }: { inBetReferral: boolean }) => ({
  type: Actions.setInBetReferral,
  inBetReferral
});

export const setActivitySession = ({ activitySession }: { activitySession: IApplicationState['activitySession'] }) => ({
  type: Actions.setActivitySession,
  activitySession
});
export const setToggleIsSportsBook = () => ({ type: Actions.toggleIsSportsBook });
export const setIsSportsBook = ({ isSportsbook }) => ({ type: Actions.setIsSportsBook, isSportsbook });
export const setChangePassword = (changePassword: boolean) => ({ type: Actions.setChangePassword, changePassword });
export const setPasswordExpiringFlow = (passwordExpiringFlow: boolean) => ({
  type: Actions.setPasswordExpiringFlow,
  passwordExpiringFlow
});
export const setModalDisplayed = (modalDisplayed: Boolean) => ({ type: Actions.setModalDisplayed, modalDisplayed });
